import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
/** @jsx jsx */
import * as colors from '@atlaskit/theme/colors';
import React, { useEffect, useRef, useCallback, useState } from 'react';
import { css, jsx } from '@emotion/react';
import Color from './color';
var palette = [['neutral', "var(--ds-background-neutral, ".concat(colors.N40, ")"), "var(--ds-border-bold, ".concat(colors.N400, ")"), "var(--ds-icon, ".concat(colors.N400, ")")], ['purple', "var(--ds-background-discovery, ".concat(colors.P50, ")"), "var(--ds-border-discovery, ".concat(colors.P400, ")"), "var(--ds-icon-discovery, ".concat(colors.P400, ")")], ['blue', "var(--ds-background-information, ".concat(colors.B50, ")"), "var(--ds-border-information, ".concat(colors.B400, ")"), "var(--ds-icon-information, ".concat(colors.B400, ")")], ['red', "var(--ds-background-danger, ".concat(colors.R50, ")"), "var(--ds-border-danger, ".concat(colors.R400, ")"), "var(--ds-icon-danger, ".concat(colors.R400, ")")], ['yellow', "var(--ds-background-warning, ".concat(colors.Y50, ")"), "var(--ds-border-warning, ".concat(colors.Y400, ")"), "var(--ds-icon-warning, ".concat(colors.Y400, ")")], ['green', "var(--ds-background-success, ".concat(colors.G50, ")"), "var(--ds-border-success, ".concat(colors.G400, ")"), "var(--ds-icon-success, ".concat(colors.G400, ")")]];
var colorPaletteWrapperStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding-left: 0px;\n  margin: ", " ", " 0\n    ", ";\n  /* Firefox bug fix: https://product-fabric.atlassian.net/browse/ED-1789 */\n  display: flex;\n  flex-wrap: wrap;\n"])), "var(--ds-space-100, 8px)", "var(--ds-space-100, 8px)", "var(--ds-space-100, 8px)");
var VK_LEFT = 37; //ArrowLeft
var VK_RIGHT = 39; //ArrowRight
var VK_UP = 38; //ArrowUp
var VK_DOWN = 40; //ArrowDown
var VK_TAB = 9;
export default (function (_ref) {
  var _ref$cols = _ref.cols,
    cols = _ref$cols === void 0 ? 7 : _ref$cols,
    onClick = _ref.onClick,
    selectedColor = _ref.selectedColor,
    className = _ref.className,
    onHover = _ref.onHover;
  var colorRefs = useRef([]);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    currentFocusedColor = _useState2[0],
    setCurrentFocusedColor = _useState2[1];
  useEffect(function () {
    colorRefs.current = colorRefs.current.slice(0, palette.length);
  }, []);
  var memoizedHandleKeyDown = useCallback(function (e) {
    var newColorIndex = null;
    var nextColor = function nextColor() {
      return currentFocusedColor + 1 > palette.length - 1 ? 0 : currentFocusedColor + 1;
    };
    var previousColor = function previousColor() {
      return currentFocusedColor - 1 < 0 ? palette.length - 1 : currentFocusedColor - 1;
    };
    switch (e.keyCode) {
      case VK_RIGHT:
      case VK_DOWN:
        e.preventDefault();
        newColorIndex = nextColor();
        break;
      case VK_LEFT:
      case VK_UP:
        e.preventDefault();
        newColorIndex = previousColor();
        break;
      case VK_TAB:
        setCurrentFocusedColor(0);
        break;
    }
    if (newColorIndex === null) {
      return;
    }
    setCurrentFocusedColor(newColorIndex);
    var newRef = colorRefs.current[newColorIndex];
    newRef === null || newRef === void 0 || newRef.focus();
  }, [currentFocusedColor, setCurrentFocusedColor, colorRefs]);
  return (
    /**
      We need to disable below eslint rule becuase of role "radiogroup". This role was added
      in https://a11y-internal.atlassian.net/browse/AK-832 to fix accessibility issue.
      When we migrated to emotion from styled component, we started getting this error.
      Task added in https://product-fabric.atlassian.net/wiki/spaces/E/pages/3182068181/Potential+improvements#Moderate-changes.
     */
    // eslint-disable-next-line jsx-a11y/interactive-supports-focus
    jsx("ul", {
      css: colorPaletteWrapperStyles,
      className: className,
      style: {
        maxWidth: cols * 32
      },
      onKeyDown: memoizedHandleKeyDown
    }, palette.map(function (_ref2, i) {
      var _ref3 = _slicedToArray(_ref2, 4),
        colorValue = _ref3[0],
        backgroundColor = _ref3[1],
        borderColor = _ref3[2],
        iconColor = _ref3[3];
      return jsx(Color, {
        key: colorValue,
        value: colorValue,
        backgroundColor: backgroundColor,
        borderColor: borderColor,
        iconColor: iconColor,
        onClick: onClick,
        onHover: onHover,
        isSelected: colorValue === selectedColor,
        tabIndex: i === 0 ? 0 : -1,
        setRef: function setRef(el) {
          return colorRefs.current[i] = el;
        }
      });
    }))
  );
});